import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { useTitle } from '../../../../hooks/useTitle';
import { useAppSelector } from '../../../../store/store';
import { useCallback } from 'react';
import { useAbilityContext } from '../../../../components/Can/Can';
import { Action } from '../../../../enums/action';
import { PAGE_TITLE } from '../../../../constants/common';
import ROUTE from '../../../../constants/route-constants';

export interface IContractScreensHeaderInteractor {
  contractName: string | undefined;
  canCreateScreen: boolean;
  canCreateCycle: boolean;
  handleCreateCycle: () => void;
  handleCreateScreen: () => void;
}

export const useContractScreensHeaderInteractor = (): IContractScreensHeaderInteractor => {
  const { contractId, clientId } = useParams();
  const navigate = useNavigate();

  const contract = useAppSelector((state) => state.contracts.contract);

  const ability = useAbilityContext();

  const handleCreateCycle = useCallback(() => {
    const path = generatePath(ROUTE.ADD_CYCLE, { clientId, contractId });
    navigate(path, { state: { contractId } });
  }, [clientId, contractId, navigate]);

  const handleCreateScreen = useCallback(() => {
    const path = generatePath(ROUTE.CREATE_SCREEN, { contractId, clientId });
    navigate(path, { state: { contractId } });
  }, [clientId, contractId, navigate]);

  useTitle(`${contract?.name}`);

  return {
    contractName: contract?.name,
    canCreateCycle: ability.can(Action.Read, PAGE_TITLE.ADD_CYCLE),
    canCreateScreen: ability.can(Action.Read, PAGE_TITLE.CREATE_SCREEN),
    handleCreateCycle,
    handleCreateScreen,
  };
};
